/* eslint-disable react/prop-types */
import { Button, Col, ColorPicker, Form, Input, message, Modal, Popover, Row, Select, Space, Spin, Table, Tooltip, Typography } from 'antd';
import React, { useEffect, useReducer, useState } from 'react';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useAuth } from '../../Context';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useFormik } from 'formik';
import axios from 'axios';
import fieldLithologyManagementReducer from './reducer';
import { FIELD_LITHOLOGY_LIST, FIELD_LITHOLOGY_LIST_ERROR, FIELD_LITHOLOGY_LIST_SUCCESS, FIELD_LITHOLOGY_UPDATE_DATA } from './constants';

// const { Title } = Typography;

export default function Crud (props) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	// const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const initalState = { loading: false, error: false, fieldLithologyData: [], updateData : {}, dasData : {} };
	const [data, dispatch] = useReducer(fieldLithologyManagementReducer, initalState);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`);

	const { wellalgorithmdata, getWellAlgorithm, handleGetMapdata, mapdata, wellFieldinfo, getWellFieldsInfo } = useAuth();

	const [addModal, setAddModal] = useState(false);   
	const [editModal, setEditModal] = useState(false);       
	const [deleteModal, setDeleteModal] = useState(false);
	const [deleteId, setDeleteId] = useState();
	const [updateId, setUpdateId] = useState();

	const [suppressionValues, setSuppressionValues] = useState([{ layers: '', depths: '', colors: '', densities: '', velocities: '' }]);	
	const [suppressionUpdateValues, setSuppressionUpdateValues] = useState([{ layers: '', depths: '', colors: '', densities: '', velocities: '' }]);
	const [suppressionViewValues, setSuppressionViewValues] = useState([{ layers: '', depths: '', colors: '', densities: '', velocities: '' }]);	
	const [viewModal, setViewModal] = useState(false);

	useEffect(() => {
		setAddModal(props.modal);
	},[props.modal]);
    
	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getWellAlgorithm(authtoken);
		handleGetMapdata(authtoken);
	},[authtoken]);
	
	const wellFields = [];
	wellFieldinfo && wellFieldinfo.map((item) => {
		wellFields.push({
			value : item.id,
			label : item.name
		});
	});

	const algoritham = [];
	wellalgorithmdata && wellalgorithmdata.data.map((item) => {		
		algoritham.push({
			value : item.id,
			label : item.name
		});
	});

	let pipelineChainage = [];
	
	mapdata &&  mapdata.map((item)=>{

		pipelineChainage.push({
			value:item.pipelineChainage,
			label:item.pipelineChainage.toString()
		});
	});	
	
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',			
		},
		{
			title: langdata && langdata.FieldName ? langdata.FieldName : 'Field Name',
			dataIndex: 'wellFieldName',
			key: 'wellFieldName',
		},
		{
			title: langdata && langdata.Layers ? langdata.Layers : 'Layers',
			dataIndex: 'lithologylayer',
			key: 'lithologylayer',

			render: (layers) => (
				<Popover
					title={langdata && langdata.Layers ? langdata.Layers : 'Layers'}
					content={Array.isArray(layers) ? layers.join(', ') : layers}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
					>
						{Array.isArray(layers) ? layers.join(', ') : layers}
					</Typography.Paragraph>
				</Popover>
			),
		},
		{
			title: langdata && langdata.Depths ? langdata.Depths : 'Depths',
			dataIndex: 'lithologydepths',
			key: 'lithologydepths',

			render: (depths) => (
				<Popover
					title={langdata && langdata.Depths ? langdata.Depths : 'Depths'}
					content={Array.isArray(depths) ? depths.join(', ') : depths}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
					>
						{Array.isArray(depths) ? depths.join(', ') : depths}
					</Typography.Paragraph>
				</Popover>
			),
		},
		{
			title: langdata && langdata.Colors ? langdata.Colors : 'Colors',
			dataIndex: 'lithologycolors',
			key: 'lithologycolors',

			render: (colors) => (
				<Popover
					title={langdata && langdata.Colors ? langdata.Colors : 'Colors'}
					content={
						<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
							{Array.isArray(colors) && colors.map((color, idx) => (
								<div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
									<div
										style={{
											width: 16,
											height: 16,
											background: color,
											border: '1px solid #ccc',
											borderRadius: 4,
											marginRight: 6,
										}}
									/>
									<span style={{ fontSize: 12 }}>{color}</span>
								</div>
							))}
						</div>
					}
					trigger="hover"
				>
					<div style={{ display: 'flex', gap: 4 }}>
						{Array.isArray(colors) && colors.map((color, idx) => (
							<div
								key={idx}
								style={{
									width: 20,
									height: 20,
									background: color,
									border: '1px solid #ccc',
									borderRadius: 4,
									marginRight: 2,
								}}
								title={color}
							/>
						))}
					</div>
				</Popover>
			),
		},
		{
			title: langdata && langdata.Densities ? langdata.Densities : 'Densities g/cm³',
			dataIndex: 'lithologydensities',
			key: 'lithologydensities',

			render: (densities) => (
				<Popover
					title={langdata && langdata.Densities ? langdata.Densities : 'Densities g/cm³'}
					content={Array.isArray(densities) ? densities.join(', ') : densities}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
					>
						{Array.isArray(densities) ? densities.join(', ') : densities}
					</Typography.Paragraph>
				</Popover>
			),
		},
		{
			title: langdata && langdata.Velocitiesms ? langdata.Velocitiesms : 'Velocities (m/s)',
			dataIndex: 'lithologyvelocities',
			key: 'lithologyvelocities',

			render: (velocities) => (
				<Popover
					title={langdata && langdata.Velocitiesms ? langdata.Velocitiesms : 'Velocities (m/s)'}
					content={Array.isArray(velocities) ? velocities.join(', ') : velocities}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
					>
						{Array.isArray(velocities) ? velocities.join(', ') : velocities}
					</Typography.Paragraph>
				</Popover>
			),
		},

		// {
		// 	title: langdata && langdata.System ? langdata.System : 'System',
		// 	key: 'system',
		// 	render: (_, record) => (
		// 		<Space size="middle">
		// 			<Space style={{justifyContent:'',display:'flex'}} size="middle">
		// 				<>
		// 					<Button style={{ display : 'contents', color : '#1FA8FF'}} onClick={() => {handleDasData(record);}}>{langdata && langdata.DAS ? langdata.DAS:'DAS'}</Button>
		// 				| <Button style={{ display : 'contents', color : '#1FA8FF'}} onClick={() => {handleDtsData(record);}}>{langdata && langdata.DTS ? langdata.DTS:'DTS'}</Button>
		// 				| <Button style={{ display : 'contents', color : '#1FA8FF'}}  onClick={() => {handlePressureData(record);}}>{langdata && langdata.Pressure ? langdata.Pressure:'Pressure'}</Button>
		// 				</>
		// 			</Space>
		// 		</Space>
		// 	)
		// },
		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {handleEditData(record);}}><EditOutlined/></a> 
					{permission==='superadmin' ?
						<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openDeleteModal(record);}} ><DeleteOutlined /></a>
						: null }
				</Space>
			)
		}
	];

	// const handleDasData = (value) => {
	// 	setDasModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	// const handleDtsData = (value) => {
	// 	setDtsModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	// const handlePressureData = (value) => {
	// 	setPressureModal(true);
	// 	dispatch({ type : WATERFALL_GRAPH_UPDATE_DATA , payload : value});
	// 	setUpdateId(value.id);
	// };

	useEffect(() => {
		loadLithology();
	},[]);
	
	const openDeleteModal = (value) => {
		setDeleteId(value.id);
		setDeleteModal(true);
	};

	const loadLithology = () => {
		dispatch({ type : FIELD_LITHOLOGY_LIST });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/fieldlithology`,
			timeout: timeout,
			headers: { 
				Authorization:`Bearer ${authtoken}`	
			}
		};

		axios.request(config)
			.then((response) => {
				if( response.status == 200) {					
					dispatch ({ type : FIELD_LITHOLOGY_LIST_SUCCESS, payload : response.data });
				} else {
					dispatch({ type : FIELD_LITHOLOGY_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : FIELD_LITHOLOGY_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const handleEditData = (value) => {
		setUpdateId(value.id);
		dispatch({ type : FIELD_LITHOLOGY_UPDATE_DATA, payload : value });
		setEditModal(true);
		const layers =  editFormik?.values?.lithologyData?.layers || [];
		const depths = editFormik?.values?.lithologyData?.depths || [];
		const colors =  editFormik?.values?.lithologyData?.colors || [];
		const densities = editFormik?.values?.lithologyData?.densities || [];
		const velocities =  editFormik?.values?.lithologyData?.velocities || [];
		
		const result = layers.map((startValue, idx) => ({
			layers: startValue,
			depths: depths[idx],
			colors: colors[idx],
			densities: densities[idx],
			velocities: velocities[idx]
		}));
		setSuppressionUpdateValues(result);
	};

	const handleViewData = (value) => {

		const layers =  value?.lithologyData?.layers || [];
		const depths = value?.lithologyData?.depths || [];
		const colors =  value?.lithologyData?.colors || [];
		const densities = value?.lithologyData?.densities || [];
		const velocities = value?.lithologyData?.velocities || [];
		
		const result = layers.map((startValue, idx) => ({
			layers: startValue,
			depths: depths[idx],
			colors: colors[idx],
			densities: densities[idx],
			velocities: velocities[idx]
		}));
		setSuppressionViewValues(result);
		setViewModal(true);
	};

	
	

	const addFormik = useFormik({
		enableReinitialize: true,
		initialValues : {
			name : null,
			wellFieldId : null,
			lithologyData : null
			
		},
		onSubmit: (values) => {
			const {name, wellFieldId} = values;

			if(name == '' || wellFieldId == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			if(!suppressionValues || suppressionValues.length > 0 && suppressionValues.some((input) => input.layers === '' || input.depths === '' || input.colors === '' || input.densities === '' || input.velocities === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			const layers = [];
			const depths = [];
			const colors = [];
			const densities = [];
			const velocities = [];
			suppressionValues && suppressionValues.map((input) => {
				layers.push(input.layers);
				depths.push(input.depths);
				colors.push(input.colors);
				densities.push(input.densities);
				velocities.push(input.velocities);
				
			});			

			let data = JSON.stringify({
				'name': name,
				'wellFieldId': wellFieldId,
				'pipelineId': parseInt(pipelineId),
				
				'lithologyData': {
					'layers': layers,
					'depths': depths,
					'colors': colors,
					'densities': densities,
					'velocities': velocities
				},
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/fieldlithology`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Litholoydetailssavedsuccessfully ? langdata.Litholoydetailssavedsuccessfully : 'Litholoy details saved successfully.' });
						loadLithology();
						setAddModal(false);
						props.setOpenModal(false);
						addFormik.resetForm();
					}else {
						Modal.warning({ title: langdata && langdata.Unabletosavelithologydetails ? langdata.Unabletosavelithologydetails : 'Unable to save lithology details' });
					}					
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavelithologydetails ? langdata.Unabletosavelithologydetails : 'Unable to save lithology details' });						
					}
				});
			addFormik.resetForm();
		}
	});		

	const editFormik = useFormik({
		enableReinitialize: true,
		initialValues : {
			name : data.updateData && data.updateData.name,
			wellFieldId : data.updateData && data.updateData.wellFieldId,
			lithologyData : data.updateData && data.updateData.lithologyData ? data.updateData.lithologyData : null,
		},
		onSubmit: (values) => {
			const {name, wellFieldId} = values;			
				
			if(name == '' || wellFieldId == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			if(!suppressionUpdateValues || suppressionUpdateValues.length > 0 && suppressionUpdateValues.some((input) => input.layers === '' || input.depths === '' || input.colors === '' || input.densities === '' || input.velocities === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}

			const layers = [];
			const depths = [];
			const colors = [];
			const densities = [];
			const velocities = [];
			suppressionUpdateValues && suppressionUpdateValues.map((input) => {
				layers.push(input.layers);
				depths.push(input.depths);
				colors.push(input.colors);
				densities.push(input.densities);
				velocities.push(input.velocities);
				
			});	

			let data = JSON.stringify({
				'name': name,
				'wellFieldId': wellFieldId,
				'pipelineId': parseInt(pipelineId),
				
				'lithologyData': {
					'layers': layers,
					'depths': depths,
					'colors': colors,
					'densities': densities,
					'velocities': velocities
				},
			});

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/fieldlithology/${updateId}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						loadLithology();
						Modal.success({ title: langdata && langdata.Litholoydetailssavedsuccessfully ? langdata.Litholoydetailssavedsuccessfully : 'Litholoy details saved successfully.' });
						setEditModal(false);
						// setDasModal(false);
						// setDtsModal(false);
						// setPressureModal(false);
						dispatch({ type : FIELD_LITHOLOGY_UPDATE_DATA, payload : null });
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavelithologydetails ? langdata.Unabletosavelithologydetails : 'Unable to save lithology details' });

					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavelithologydetails ? langdata.Unabletosavelithologydetails : 'Unable to save lithology details' });
					}
				});
			editFormik.resetForm();
		}
	});		

		
	useEffect(() => {

		const layers =  editFormik?.values?.lithologyData?.layers || [];
		const depths = editFormik?.values?.lithologyData?.depths || [];
		const colors =  editFormik?.values?.lithologyData?.colors || [];
		const densities = editFormik?.values?.lithologyData?.densities || [];
		const velocities =  editFormik?.values?.lithologyData?.velocities || [];
		
		const result = layers.map((startValue, idx) => ({
			layers: startValue,
			depths: depths[idx],
			colors: colors[idx],
			densities: densities[idx],
			velocities: velocities[idx]
		}));
		setSuppressionUpdateValues(result);
	},[editFormik?.values?.lithologyData]);
		

	const handleDelete = () => {

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/fieldlithology/${deleteId}`,
			timeout: timeout,
			headers: { 
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201) {
					Modal.success({ title: langdata && langdata.Litholoydetailssuccessfullydeleted ? langdata.Litholoydetailssuccessfullydeleted : 'Litholoy details successfully deleted.' });
					loadLithology();		
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletelitholoydetails ? langdata.Unabletodeletelitholoydetails : 'Unable to delete litholoy details.' });
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletelitholoydetails ? langdata.Unabletodeletelitholoydetails : 'Unable to delete litholoy details.' });
				}
			});
		setDeleteModal(false);
	};

	const handleOk = () => {
		setAddModal(false);
		props.setOpenModal(false);
		setEditModal(false);
		setDeleteModal(false);
		// setDasModal(false);
		// setDtsModal(false);
		// setPressureModal(false);
		editFormik.resetForm();
		addFormik.resetForm();
	};
	const handleCancel = () => {
		setSuppressionValues([{ layers: '', depths: '', colors: '', densities: '', velocities: '' }]);
		setSuppressionUpdateValues([{ layers: '', depths: '', colors: '', densities: '', velocities: '' }]);
		setAddModal(false);
		props.setOpenModal(false);
		setEditModal(false);
		setDeleteModal(false);
		setViewModal(false);
		// setDasModal(false);
		// setDtsModal(false);
		// setPressureModal(false);
		editFormik.resetForm();
		addFormik.resetForm();
	};

	const handleChangeSuppression = (index, field, value) => {
		
		const newSuppressionValues = [...suppressionValues];
		newSuppressionValues[index][field] = value;
		setSuppressionValues(newSuppressionValues);
	};

	const handleAddSuppression = () => {
		setSuppressionValues([...suppressionValues, { layers: '', depths: '', colors: '', densities: '', velocities: '' }]);
	};

	const handleDeleteSuppression = (index) => {
		setSuppressionValues(suppressionValues.filter((_, i) => i !== index));
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleUpdateChangeSuppression = (index, field, value) => {
		const newSuppressionValues = [...suppressionUpdateValues];
		newSuppressionValues[index][field] = value;
		setSuppressionUpdateValues(newSuppressionValues);
	};

	const handleUpdateAddSuppression = () => {
		setSuppressionUpdateValues([...suppressionUpdateValues, { layers: '', depths: '', colors: '', densities: '', velocities: '' }]);
	};

	const handleUpdateDeleteSuppression = (index) => {
		setSuppressionUpdateValues(suppressionUpdateValues.filter((_, i) => i !== index));
	};

	return (
		<>			
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					<Table
						scroll={{
							x: 900,
						}}
						columns = { columns } 
						dataSource = { data.fieldLithologyData }
						onRow={(record) => ({
							onClick: (event) => {
								if (
									event.target.closest('.ant-space') || 
									event.target.closest('.ant-btn') || 
									event.target.closest('.anticon')
								) {
									return;
								}
								handleViewData(record);
							}
						})}
					/>

				</Col>
			</Row>
			<Modal
				title={langdata && langdata.AddLithology ? langdata.AddLithology : 'Add Lithology'}
				centered
				open={addModal}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={addFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Name ? langdata.Name : 'Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthelithologyname ? langdata.Pleaseenterthelithologyname : 'Please enter the lithology name' }]} required>
								<Input 
									name="name" 
									// onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthelithologyname ? langdata.Pleaseenterthelithologyname : 'Please enter the lithology name'}
									onChange={(e) => addFormik.setFieldValue('name', e.target.value)}
									value={addFormik.values.name}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field' }]} required>
								<Select 
									name="wellFieldId" 
									placeholder={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field'}
									onChange={(value) => addFormik.setFieldValue('wellFieldId', value)}
									value={addFormik.values.wellFieldId}
									options={wellFields}
								/>
							</Form.Item>
						</Col>
						
					</Row>					
					
					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Lithology ? langdata.Lithology:'Lithology'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleAddSuppression}
							/>
						</Col>
					</Row>
					{/* <Divider/> */}
					{suppressionValues.map((input, index) => (						
						<Row gutter={24} key={index}>
							<Col span={6}>
								<Form.Item
									label={langdata?.Layers || 'Layers'}
									
								>
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										placeholder={langdata?.Pleaseenterthelayername || 'Please enter the layer name'}									
										allowClear
										onChange={e => handleChangeSuppression(index, 'layers', e.target.value)}
									/>
								</Form.Item>
							</Col>
							<Col span={4}>
								<Form.Item
									label={langdata?.Depths || 'Depths'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										type='number'
										min={0}
										// showSearch
										// filterOption={filterOption}
										onChange={(e) => {e.target.value >= 0 ? handleChangeSuppression(index, 'depths', e.target.value) : '';}}
										placeholder={langdata?.Pleaseselectthedepth || 'Please select the depth'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
									/>
								</Form.Item>
							</Col>

							<Col span={2}>
								<Form.Item
									label={langdata?.Colors || 'Colors'}
								>
									<Tooltip title ={langdata?.Pleasechooseacolor || 'Please choose a color'}>

										<ColorPicker
											style={{ margin: '5px' }}
											value={input.colors}
											onChange={color => handleChangeSuppression(index, 'colors', color?.toHexString())}
											allowClear
										/>
									</Tooltip>
								</Form.Item>
							</Col>
							
							<Col span={4}>
								<Form.Item
									label={langdata?.Densities || 'Densities g/cm³'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayerdensity || 'Please enter the layer density'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										// value={input.End}
										onChange={e => handleChangeSuppression(index, 'densities', e.target.value)}
									/>
								</Form.Item>
							</Col>

							<Col span={6}>
								<Form.Item
									label={langdata?.Velocitiesms || 'Velocities (m/s)'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayervelocity || 'Please enter the layer velocity'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										// value={input.End}
										onChange={e => handleChangeSuppression(index, 'velocities', e.target.value)}
									/>
								</Form.Item>
							</Col>


							<Col span={2} style={{ marginTop: '33px', textAlign: 'center' }}>
								<Button
									danger
									icon={<DeleteOutlined />}
									onClick={() => handleDeleteSuppression(index)}
									disabled={suppressionValues.length === 0}
								/>
							</Col>
						</Row>
					))}
				</Form>
			</Modal>

			<Modal
				title={langdata && langdata.EditLithology ? langdata.EditLithology : 'Edit Lithology'}
				centered
				open={editModal}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFormik.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>

						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.Name ? langdata.Name : 'Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthelithologyname ? langdata.Pleaseenterthelithologyname : 'Please enter the lithology name' }]} required>
								<Input 
									name="name" 
									// onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthelithologyname ? langdata.Pleaseenterthelithologyname : 'Please enter the lithology name'}
									onChange={(e) => editFormik.setFieldValue('name', e.target.value)}
									value={editFormik.values.name}
									min={0}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item 
								label={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field' }]} required>
								<Select 
									name="wellFieldId" 
									placeholder={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field'}
									onChange={(value) => editFormik.setFieldValue('wellFieldId', value)}
									value={editFormik.values.wellFieldId}
									options={wellFields}
									filterOption={filterOption}
									optionFilterProp="children"
								/>
							</Form.Item>
						</Col>

					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Lithology ? langdata.Lithology:'Lithology'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleUpdateAddSuppression}
							/>
						</Col>
					</Row>

					{suppressionUpdateValues.map((input, index) => (						
						
						<Row gutter={24} key={index}>
							<Col span={6}>
								<Form.Item
									label={langdata?.Layers || 'Layers'}
									
								>
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										placeholder={langdata?.Pleaseenterthelayername || 'Please enter the layer name'}									
										allowClear
										onChange={e => handleUpdateChangeSuppression(index, 'layers', e.target.value)}
										value={input.layers && input.layers !== '' ? input.layers : null}
									/>
								</Form.Item>
							</Col>
							<Col span={4}>
								<Form.Item
									label={langdata?.Depths || 'Depths'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										type='number'
										min={0}
										// showSearch
										// filterOption={filterOption}
										onChange={(e) => {e.target.value >= 0 ? handleUpdateChangeSuppression(index, 'depths', e.target.value) : '';}}
										placeholder={langdata?.Pleaseselectthedepth || 'Please select the depth'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										value={input.depths && input.depths !== '' ? input.depths : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
									/>
								</Form.Item>
							</Col>

							<Col span={2}>
								<Form.Item
									label={langdata?.Colors || 'Colors'}
								>
									<Tooltip title ={langdata?.Pleasechooseacolor || 'Please choose a color'}>

										<ColorPicker
											style={{ margin: '5px' }}
											// value={input.colors}
											onChange={color => handleUpdateChangeSuppression(index, 'colors', color?.toHexString())}
											allowClear
											value={input.colors && input.colors !== '' ? input.colors : null}
										/>
									</Tooltip>
								</Form.Item>
							</Col>
							
							<Col span={4}>
								<Form.Item
									label={langdata?.Densities || 'Densities g/cm³'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayerdensity || 'Please enter the layer density'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										// value={input.End}
										onChange={e => handleUpdateChangeSuppression(index, 'densities', e.target.value)}
										value={input.densities && input.densities !== '' ? input.densities : null}
									/>
								</Form.Item>
							</Col>

							<Col span={6}>
								<Form.Item
									label={langdata?.Velocitiesms || 'Velocities (m/s)'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayervelocity || 'Please enter the layer velocity'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										allowClear
										// value={input.End}
										onChange={e => handleUpdateChangeSuppression(index, 'velocities', e.target.value)}
										value={input.velocities && input.velocities !== '' ? input.velocities : null}
									/>
								</Form.Item>
							</Col>


							<Col span={2} style={{ marginTop: '33px', textAlign: 'center' }}>
								<Button
									danger
									icon={<DeleteOutlined />}
									onClick={() => handleUpdateDeleteSuppression(index)}
									disabled={suppressionUpdateValues.length === 0}
								/>
							</Col>
						</Row>
							
					))}
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.Lithology ? langdata.Lithology : 'Lithology'}
				centered
				open={viewModal}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Lithology ? langdata.Lithology:'Lithology'}</b></Typography>
						</Col>
					</Row>

					{suppressionViewValues.map((input, index) => (						
						
						<Row gutter={24} key={index}>
							<Col span={5}>
								<Form.Item
									label={langdata?.Layers || 'Layers'}
									
								>
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										disabled
										placeholder={langdata?.Pleaseenterthelayername || 'Please enter the layer name'}									
										value={input.layers && input.layers !== '' ? input.layers : null}
									/>
								</Form.Item>
							</Col>
							<Col span={6}>
								<Form.Item
									label={langdata?.Depths || 'Depths'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										type='number'
										min={0}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseselectthedepth || 'Please select the depth'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.depths && input.depths !== '' ? input.depths : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
									/>
								</Form.Item>
							</Col>

							<Col span={2}>
								<Form.Item
									label={langdata?.Colors || 'Colors'}
								>
									<Tooltip title ={langdata?.Pleasechooseacolor || 'Please choose a color'}>

										<ColorPicker
											style={{ margin: '5px' }}
											// value={input.colors}
											disabled
											value={input.colors && input.colors !== '' ? input.colors : null}
										/>
									</Tooltip>
								</Form.Item>
							</Col>
							
							<Col span={6}>
								<Form.Item
									label={langdata?.Densities || 'Densities g/cm³'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayerdensity || 'Please enter the layer density'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.densities && input.densities !== '' ? input.densities : null}
									/>
								</Form.Item>
							</Col>

							<Col span={5}>
								<Form.Item
									label={langdata?.Velocitiesms || 'Velocities (m/s)'}
									
								>
									{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
									<Input
										style={{ minWidth: '100px', margin:'5px'}}
										// showSearch
										// filterOption={filterOption}
										placeholder={langdata?.Pleaseenterthelayervelocity || 'Please enter the layer velocity'}
										// optionFilterProp="children"
										// options={pipelineChainage}
										disabled
										value={input.velocities && input.velocities !== '' ? input.velocities : null}
									/>
								</Form.Item>
							</Col>
						</Row>
							
					))}
				</Form>
			</Modal>


			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={deleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis :'Are you sure you want to delete this?'}</Col>
				</Row>
			</Modal>
			<Spin fullscreen spinning={data.loading} />
		</>
	);
}